import type { ReactNode } from 'react';
import { Button, type ButtonProps } from '@farmos/ui/button';
import { cn } from '@farmos/ui/utils';

/** The round, floating buttons at the top of a screen. */
export function RoundButton({ className, ...props }: ButtonProps) {
  return (
    <Button
      variant="secondary"
      size="icon"
      className={cn(
        'border-0 bg-panel/80 text-muted shadow-card backdrop-blur hover:text-ink',
        className,
      )}
      {...props}
    />
  );
}

/** A screen's title, centered between an optional button on each side. */
export function TopBar({
  start,
  title,
  end,
}: {
  start?: ReactNode;
  title: ReactNode;
  end?: ReactNode;
}) {
  return (
    <header className="grid grid-cols-[2.75rem_1fr_2.75rem] items-center gap-2 px-3 pb-2 pt-[max(env(safe-area-inset-top),0.75rem)]">
      <div>{start}</div>
      <h2 className="truncate text-center text-[17px] font-semibold" dir="auto">
        {title}
      </h2>
      <div>{end}</div>
    </header>
  );
}
